import {AutorunComponent} from '@myshared/autorun.component';
import {Component, OnInit} from '@angular/core';
import {InvoiceService} from '../invoice.service';
import {action} from '@myshared/mobx-connector';
import {Invoice} from "@proto/odoo/invoice";
import {firstValueFrom} from "rxjs";
import {matchFilter} from "@myshared/utils";
import {pcDate} from "../../date.service";

@Component({
    selector: 'app-order-invoices',
    templateUrl: './order-invoices.component.html',
    standalone: false
})
export class OrderInvoicesComponent extends AutorunComponent implements OnInit {
    public invoices: Invoice[] = [];
    public filteredInvoices: Invoice[] = [];
    private offset = 0;
    private needsLoadMore = false;

    constructor(private invoiceService: InvoiceService) {
        super();
    }

    async ngOnInit() {
        await this.loadInvoices();
    }

    @action
    doFilter(filter: string) {
        this.filteredInvoices = matchFilter<Invoice>(this.invoices, filter, (key, value) => {
            if (key === 'date') return pcDate(value).formatDate()
            return value;
        });
    }

    async nextPage() {
        this.offset = this.offset + 20;
        await this.loadInvoices();
    }

    get needsPagination(): boolean {
        return this.invoices && this.invoices.length >= 20 && this.invoices.length % 20 == 0 && this.needsLoadMore;
    }

    private async loadInvoices() {
        this.needsLoadMore = false;
        const invoices = await firstValueFrom(this.invoiceService.getInvoices(this.offset));
        if (invoices.length >= 20) this.needsLoadMore = true
        this.invoices.push(...invoices)
        this.filteredInvoices = this.invoices;
    }
}
